import React, { useEffect } from 'react'
import { App as CapacitorApp } from '@capacitor/app';
import { Routes } from '../../constants/RouteConstants';
import { useNavigate } from 'react-router-dom';

const OfflinePage = () => {

    const navigate = useNavigate();
    useEffect(() => {
        const handleBackButton = () => {
            CapacitorApp.exitApp();
        };
        CapacitorApp.addListener('backButton', handleBackButton);
        return () => {
            CapacitorApp.removeAllListeners();
        };
    }, [navigate]);


    return (
        <section className="page_404 text-center">
            <div className="container">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="four_zero_four_bg">

                        </div>
                        <div className="contant_box_404">
                            <p className='txt_not_found'>You are currently offline.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default OfflinePage